import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrderProvider } from '../providers/order.provider';
import { OrderSignedInterface, SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface SignOrderUseCaseParams {
    product: SelectedProductInterface;
}

@Injectable()
export class SignOrderUseCase implements UseCaseWithParam<SignOrderUseCaseParams, Observable<Transaction<OrderSignedInterface>>> {
    constructor(private orderProvider: OrderProvider) {}

    bind(params: SignOrderUseCaseParams): Observable<Transaction<OrderSignedInterface>> {
        return this.orderProvider.sign(params.product).pipe(
            map((transaction) =>
                transaction.map(
                    (data) => Transaction.success(cloneDeep(data)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
